import React, { useState, useEffect } from "react";
import { Link, Navigate, useNavigate, useParams } from "react-router-dom"; // Using react-router to get user ID from URL
import Loading from "../utils/Loading";
import { getRoleDisplay } from "../utils/getRoleDisplay";
import { USERS_BASE_URL } from "../services/SignUpService";
import Swal from "sweetalert2";
import axios from "axios";
import { useAuthContext } from "../hooks/useAuthContext";

export const UserProfile = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  // const { user } = useAuthContext();
  const navigate = useNavigate();

  const [user, setUser] = useState({
    photo: "",
    firstName: "",
    lastName: "",
    email: "",
    role: "",
    isAdmin: "",
    isVerified: "",
    createdAt: "",
  });

  const { id } = useParams(); // Fetch user id from URL params

  // Function to delete a user
  const deleteUser = async (e, _id) => {
    e.preventDefault();
    try {
      const confirmResult = await Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      });

      if (confirmResult.isConfirmed) {
        await axios.delete(`${USERS_BASE_URL}/api/users/list/delete/${_id}`, {
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
        });
        Swal.fire({
          title: "Deleted!",
          text: "User has been deleted.",
          icon: "success",
          timer: 2000888888,
        });
        navigate("/api/dashboard/users");
        // fetchCourseData(); // Reload users list right away
      }
    } catch (error) {
      //Failed to delete user!
      console.error("Error deleting user: ", error);
      Swal.fire({
        title: "Error!",
        text: `Failed to delete user! Error: ${error.message}`,
        icon: "error",
        timer: 2000,
      });
    }
  };

  const fetchCourseData = async () => {
    try {
      const response = await fetch(`${USERS_BASE_URL}/api/users/list/${id}`);
      if (!response.ok) {
        throw new Error("Failed to fetch course data");
      }
      const data = await response.json();
      setUser(data);
      setLoading(false);
    } catch (err) {
      setError(err);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCourseData();
  }, [id]);

  if (loading) {
    return (
      <div className="text-center">
        <Loading />
      </div>
    );
  }

  if (error) {
    return <div className="alert alert-danger">{error.message}</div>;
  }

  if (error) {
    return <div className="text-center text-danger">{error}</div>;
  }

  if (!user) {
    return (
      <div className="text-center">
        <p>No user found!.</p>
      </div>
    );
  }

  return (
    <section className="profile text-muted">
      <h1 className="bg-white p-3">
        User Profile <hr />
      </h1>

      <div className="container mt-4 mb-4">
        <div className="row">
          <div className="col">
            <div className="card text-center">
              <div className="card-body">
                <img
                  src={user.avatar || "https://i.pravatar.cc/50"}
                  alt="User Profile"
                  className="rounded-circle mb-3"
                  style={{ width: "50px", height: "50px" }}
                />
                <h5>
                  {user.firstName.slice()} {user.lastName.slice(0, 1)}
                </h5>
              </div>
            </div>
          </div>

          <div className="col">
            <div className="card text-muted">
              <div className="card-header">
                <h6 className="card-title">
                  <span className="lead">
                    Welcome,{" "}
                    <i>
                      {user.firstName} {user.lastName}{" "}
                    </i>
                  </span>
                </h6>
                <hr />
                <div className="float-end p-2">
                  <b>Admin: &nbsp; </b>
                  {user.isAdmin ? (
                    <>
                      <i
                        className="fa fa-unlock-alt text-success"
                        aria-hidden="true"
                      ></i>{" "}
                      &nbsp;
                      <div className="btn btn-outline-success btn-sm">YES</div>
                    </>
                  ) : (
                    <>
                      <i
                        className="fa fa-lock text-danger"
                        aria-hidden="true"
                      ></i>{" "}
                      &nbsp;
                      <div className="btn btn-outline-danger btn-sm">NO</div>
                    </>
                  )}
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <b>Verified: &nbsp; </b>
                  {user.isVerified ? (
                    <>
                      <i
                        className="fa fa-check-square text-success"
                        aria-hidden="true"
                      ></i>
                      &nbsp;&nbsp;
                      <div className="btn btn-outline-success btn-sm">YES</div>
                    </>
                  ) : (
                    <>
                      <i
                        className="fa fa-ban text-danger"
                        aria-hidden="true"
                      ></i>{" "}
                      <div className="btn btn-outline-danger btn-sm">NO</div>
                    </>
                  )}
                </div>
              </div>

              <div className="card-body">
                <div className="cart-text">
                  <h5>First Name</h5>
                  <div className="input-group mb-3">
                    <input
                      type="text"
                      className="form-control text-uppercase me-2"
                      placeholder="First Name"
                      value={user.firstName || ""}
                      disabled
                    />
                  </div>
                  <h5>Last Name</h5>
                  <div className="input-group mb-3">
                    <input
                      type="text"
                      className="form-control text-uppercase me-2"
                      placeholder="Last Name"
                      value={user.lastName || ""}
                      disabled
                    />
                  </div>
                  {/* Email */}
                  <h5>Email Address</h5>
                  <div className="input-group mb-3">
                    <input
                      type="text"
                      className="form-control text-uppercase me-2"
                      placeholder="Email address"
                      value={user.email || ""}
                      disabled
                    />
                  </div>
                  {/* Role */}
                  <h5>Role</h5>
                  <div className="input-group mb-3">
                    <input
                      type="text"
                      className="form-control text-uppercase me-2"
                      placeholder={user.isAdmin ? user.role : "Normal User"}
                      // value={getRoleDisplay(user) || "No role"}
                      //     {user.role.join(", ")}
                      value={user.isAdmin ? user.role.join(", ") : user.role}
                      disabled
                    />
                  </div>

                  {/* Joined */}
                  <p className="card-text text-muted mb-0 mt-4">
                    <strong>Joined:</strong>{" "}
                    {user.createdAt
                      ? new Date(user.createdAt).toLocaleDateString()
                      : ""}
                  </p>
                </div>
              </div>
            </div>

            <div className="d-flex mt-4 mb-4">
              {/* Back */}
              <Link
                to="/api/dashboard/users"
                className="btn btn-outline-dark btn-lg me-4"
                title="Back"
              >
                <i className="fa fa-chevron-left"></i> Back
              </Link>

              <Link
                to={`/api/dashboard/update-user/${user._id}`}
                className="btn btn-outline-info btn-lg me-2"
                title="Edit"
              >
                <i className="fa fa-pencil-square-o"></i> Edit
              </Link>

              {user.isAdmin ? (
                <button
                  className="btn btn-outline-danger btn-lg"
                  disabled={user.isAdmin}
                  onClick={(e) => deleteUser(e, user._id)}
                >
                  <i className="fa fa-trash"></i> Delete Account
                </button>
              ) : (
                <button className="btn btn-outline-danger btn-lg">
                  <i className="fa fa-trash"></i> Close Account
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
